import { DASHBOARD_CARDS_VALUE, LOAD_DASHBOARD_CARDS } from './types';

export function dashboardCardAction(data) {
  return {
    type: DASHBOARD_CARDS_VALUE,
    payload: data
  }
}

export function loadDashboardCards(data) {
  return {
    type: LOAD_DASHBOARD_CARDS,
    payload: data
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/actions.js